import { z } from 'zod';

/** @see cfa.d2c.frontend.customer.v1.CustomerType */
export const CustomerType = {
  UNSPECIFIED: 0,
  US_CFA: 1,
  US_ANONYMOUS: 2,
  CA_CFA: 3,
  CA_ANONYMOUS: 4,
  FEEDBACK: 5,
};

export const customerTypeSchema = z.union([
  z.literal(CustomerType.UNSPECIFIED),
  z.literal(CustomerType.US_CFA),
  z.literal(CustomerType.US_ANONYMOUS),
  z.literal(CustomerType.CA_CFA),
  z.literal(CustomerType.CA_ANONYMOUS),
  z.literal(CustomerType.FEEDBACK),
  z.literal('CUSTOMER_TYPE_UNSPECIFIED'),
  z.literal('CUSTOMER_TYPE_US_CFA'),
  z.literal('CUSTOMER_TYPE_US_ANONYMOUS'),
  z.literal('CUSTOMER_TYPE_CA_CFA'),
  z.literal('CUSTOMER_TYPE_CA_ANONYMOUS'),
  z.literal('CUSTOMER_TYPE_FEEDBACK'),
]);

export const personNameSchema = z.object({
  givenName: z.string(),
  familyName: z.string(),
});

export const corePhoneNumberSchema = z.object({
  base: z.string(),
  extension: z.string().optional(),
});

export const emailAddressSchema = z.object({
  value: z.string(),
  verified: z.boolean(),
});

export const phoneNumberSchema = z.object({
  value: corePhoneNumberSchema.optional(),
  verified: z.boolean(),
});

export const googleDateSchema = z.object({
  year: z.number(),
  month: z.number(),
  day: z.number(),
});

export const timestampSchema = z.object({
  seconds: z.union([z.string(), z.number(), z.bigint()]),
  nanos: z.number().optional(),
});

export const membershipDetailsSchema = z.object({
  createdAt: timestampSchema.optional(),
  cardNumber: z.string(),
  modifiedAt: timestampSchema.optional(),
});

export const idMeStatusInfoSchema = z.object({
  group: z.string(),
  subgroups: z.array(z.string()),
  verified: z.boolean(),
});

export const deliveryAddressSchema = z.looseObject({
  id: z.string(),
  googlePlaceId: z.string(),
});

/**
 * Chick-fil-A customer record from `cfa.d2c.frontend.customer.v1.Customer`.
 * @see GetCustomerResponse.customer
 */
export const customerSchema = z.object({
  id: z.string(),
  name: personNameSchema.optional(),
  deliveryAddresses: z.array(deliveryAddressSchema),
  emailAddress: emailAddressSchema.optional(),
  phoneNumber: phoneNumberSchema.optional(),
  birthdate: googleDateSchema.optional(),
  membershipDetails: membershipDetailsSchema.optional(),
  customerType: customerTypeSchema,
  secondaryEmail: emailAddressSchema.optional(),
  hasPendingPrimaryEmailUpdate: z.boolean().optional(),
  socialLoginAccount: z.boolean().optional(),
  idMeStatusInfo: z.array(idMeStatusInfoSchema),
});

/**
 * ConnectRPC `CustomerService.GetCustomer` response.
 * @see cfa.d2c.frontend.customer.v1.GetCustomerResponse
 */
export const getCustomerResponseSchema = z.object({
  customer: customerSchema.optional(),
});
